import React, {useState, useEffect}from "react";
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from "reactstrap"

const Footer = ({lang}) => {
  const [isDropdown, setIsDropdown] = useState(false)
  
  return <>
  <div>
    <footer>
      <div className="key_download-container">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
            <h5>{lang.footer.online_products}</h5>
              <ul>
                <li>
                  <a
                    href="https://travel.berjayasompo.com.my/TravelSafe/agentIndex?agentid=HQ8180004"
                    target="_blank"
                  >
                    Secure TravelSafe
                  </a>
                </li>
                <li>
                  <a
                    href="https://customer.berjayasompo.com.my/directsales/sh?account_code=10006833#/"
                    target="_blank"
                  >
                    Secure Home
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Medz"
                    target="_blank"
                  >
                    Snatch Medz+
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.berjayasompo.com.my/Snatch/agentIndex?agentid=HQ8180004&product=Shield"
                    target="_blank"
                  >
                    Snatch Shield Plus
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <h5>{lang.footer.key_downloads.title}</h5>
              <ul>
                <li>
                  <a href={lang.docs.sc_pds} target="_blank" >
                    {lang.footer.key_downloads.PDS}
                  </a>
                </li>
                <li>
                  <a href={lang.docs.sc_pw} target="_blank" >
                    {lang.footer.key_downloads.PW}
                  </a>
                </li>
                <li>
                  <a href="/securemotor/authorised-panel-workshops">
                  {lang.footer.key_downloads.authorised_panel_workshops}
                  </a>
                </li>
                <li>
                  <a
                    href={lang.docs.sc_tnc}
                    target="_blank"
                  >
                    {lang.footer.key_downloads.TnC_instalment}
                  </a>
                </li>
                <li>
                  <a href={lang.docs.sc_rakan} target="_blank">
                  {lang.footer.key_downloads.rakan_auto}
                  </a>
                </li>
              </ul>
            </div>
            {/* <div className="col-md-4">
				<h5>CONTACT US</h5>
				<div className="icon">
					<i className="fa fa-phone" aria-hidden="true"></i>
				</div>
				<div className="text">
					<ul>
						<li className="bold">Customer Service</li>
						<li>8:30 AM - 5:00 PM (Monday to Friday)</li>
						<li>1 800 889 933 (within Malaysia)</li>
						<li>+603 2170 7300 (overseas)</li>
						<li>24/7 Worldwide Assistance </li>
						<li>+603 7628 3860 / +603 7841 5770</li>
					</ul>
				</div>
			</div> */}

            <div className="col-md-4">
            <h5>{lang.footer.contact_us}</h5>
              {/* <div className="icon">
					<i className="fa fa-map-marker" aria-hidden="true"></i>
				</div> */}
              <div className="text">
                <ul>
                <li className="bold">{lang.footer.address}</li>
                  {/* <li className="bold">Berjaya Sompo Insurance Berhad
							Registration No: 198001008821 (62605-U)</li> */}
                  <li>
                    Level 36, Menara Bangkok Bank, 105, Jalan Ampang, 50450
                    Kuala Lumpur
                  </li>
                </ul>
              </div>
              <div className="text mt-3">
                <ul>
                <li className="bold">{lang.footer.customer_service.title}</li>
                  <li>{lang.footer.customer_service.line_01}</li>
                  <li>{lang.footer.customer_service.line_02}</li>
                  <li>{lang.footer.customer_service.line_03}</li>
                  <li className="mt-2">{lang.footer.customer_service.line_04}</li>
                  <li>+603 7628 3860 / +603 7841 5770</li>
                  <li className="mt-2">
                  {lang.footer.customer_service.line_05}
                  </li>
                  <li>1800 18 8033</li>
                  <li className="mt-2">
                  {lang.footer.customer_service.line_06}
                  </li>
                  <li>1300 88 2323</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="social-media_container">
        <div className="container">

        <div>
            <ul className="navbar-nav ml-auto">
              <Dropdown nav={true} isOpen={isDropdown} toggle={() => setIsDropdown(prevState => !prevState)}>
                <DropdownToggle  className="nav-item dropdown ml-auto btn-footer btn-footer-secondary" caret>
                {lang.id === 'BM' ? 'Bahasa' : 'English'}
                </DropdownToggle>
								<DropdownMenu>
									<DropdownItem className={lang.id === 'BM' ? 'hidden' : ''} href={lang.homeLinks.bm} >
									Bahasa
									</DropdownItem>
									<DropdownItem className={lang.id === 'EN' ? 'hidden' : ''} href={lang.homeLinks.en} >
									English
									</DropdownItem>
								</DropdownMenu>
              </Dropdown>
            </ul>

          </div>

          <div className="row social-media">
            <div className="col-lg-4 col-md-6 offset-md-6 offset-lg-8">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/berjayasompoinsurance/"
                    rel="noreferrer"
                  >
                    <img
                      src={"/securemotor/images/ico-fb.svg"}
                      alt="Facebook"
                      height="40" width="40"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/berjayasompoinsurance/"
                    rel="noreferrer"
                  >
                    <img
                      src={"/securemotor/images/ico-instagram.svg"}
                      alt="Instagram"
                      height="40" width="40"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/c/BerjayaSompoInsurance"
                    rel="noreferrer"
                  >
                    <img
                      src={"/securemotor/images/ico-utube.svg"}
                      alt="Youtube"
                      height="40" width="40"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/berjaya-sompo-insurance-berhad/"
                    rel="noreferrer"
                  >
                    <img
                      src={"/securemotor/images/ico-linkedin.svg"}
                      alt="Linkedin"
                      height="40" width="40"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-footer_container justify-content-center d-flex">
        <div className="container d-lg-inline-flex d-md-block">
          <div className="row col-md-12 col-lg-10 bottom-footer">
            <div className="col-md-7">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/terms-conditions"
                  >
                    {lang.footer.general_policy_terms}
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/privacy-notice"
                  >
                    {lang.footer.privacy_notice}
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/legal-notice"
                  >
                    {lang.footer.legal_notice}
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/disclaimer"
                  >
                    {lang.footer.disclaimer}
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/whistle-blowing-policy"
                  >
                    {lang.footer.whistle_blowing_policy}
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.berjayasompo.com.my/customer-service-charter"
                  >
                    {lang.footer.customer_servie_charter}
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                  >
                    {lang.footer.PIDM_tips_brochure}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-5 copy">
              <div className="d-inline-block">
              {lang.footer.copyright} © 2025 Berjaya Sompo Insurance Berhad <br />{" "}
              {lang.footer.registration_no}: 198001008821 (62605-U)
              </div>
            </div>
            <div class="pidm-disclosure col-md-12 pl-0">
              <>
                <div className="col-md-10 d-inline-block">
                  {lang.footer.PIDM.line_01}
                  <a
                    href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                    target="_blank"
                  >
                    {" "}
                    {lang.footer.PIDM.line_02}{" "}
                  </a>{" "}
                  {lang.footer.PIDM.line_03}{" "}
                  <a href="https://www.pidm.gov.my" target="_blank">
                    www.pidm.gov.my
                  </a>
                  ).
                </div>
              </>
            </div>
          </div>
          <div className="d-inline-flex justify-content-center p-2 col-md-12 col-lg-2">
            <a
              class="footer-minilogo"
              href="https://www.pidm.gov.my/my"
              target="_blank"
            >
              <img src="/securemotor/images/footlogo-bigpidm.jpg" alt="PIDM" height="70" width="96" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
  </>
}

export default Footer;
